export const THANK_YOU_SET_VALUE = 'easiplusFuneralPlan/thankYou/setValue/';

export const REFERENCE_NUMBER_SET_VALUE = THANK_YOU_SET_VALUE + 'referenceNumber';
export const FIRST_NAMES_SET_VALUE = THANK_YOU_SET_VALUE + 'firstNames';

export const setReferenceNumberValue = value => ({ type: REFERENCE_NUMBER_SET_VALUE, value });
export const setFirstNamesValue = value => ({ type: FIRST_NAMES_SET_VALUE, value });
